import React from "react";
import Header from "../header/header";
import HeaderImageSection from "../shared/headerImageSection";
import FooterComponent from "../footerComponent/footerComponent";
import events from "../../assets/events.png";

const Events = () => {
return(
    <>
    <Header />
    <HeaderImageSection />
    <section className="d-flex align-items-center justify-content-center">
        <div className="row sectionCenter mt-4 p-2 d-flex align-items-center">
          <div className="col-sm-12 col-md-6">
            <img alt='' src={events}/>
          </div>
          <div className="col-sm-12 col-md-6 ">
            <p>At Kumbharmangalam®, we specialize in connecting individuals within the Kumbhar community, making it easier for you to find your ideal match. With countless success stories from couples who have found happiness through the Kumbhar Vadhu Var Suchak Mandal, </p>
            <p>Our personalized matchmaking services cater to your unique preferences, helping you navigate the journey of finding a life partner. Join us today and experience a stress-free process dedicated to helping you build a happy, meaningful life together within the Kumbhar Samaj!</p>
          </div>
        </div>
      </section>
    <FooterComponent />
    </>
)
}
export default Events;